import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const userManagementStyles = makeStyles((theme: Theme) =>
    createStyles({
        addButton: {
            backgroundColor: "#270ADC",
            color: "white",
            fontWeight: 300,
            fontSize: "16px",
            padding: "15px",
            marginBottom: "10px",

            "&:hover": {
                backgroundColor: theme.colors.primary.blue600,
            },
        },

        customerDropdown: {
            margin: "5px",
            display: "block",
        },
    })
);
